exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.el-checkbox__input.is-checked .el-checkbox__inner {\n  background-color: #5562B4;\n  border-color: #5562B4;\n}\n.el-checkbox__input.is-checked + .el-checkbox__label {\n  color: #5562B4;\n}", "", {"version":3,"sources":["D:/WorkProjects-git/MultCloud/Project/mcFrontend/src/components/workspace/lite_file.vue"],"names":[],"mappings":";AAAA;EACE,0BAA0B;EAC1B,sBAAsB;CACvB;AAED;EACE,eAAe;CAChB","file":"lite_file.vue","sourcesContent":[".el-checkbox__input.is-checked .el-checkbox__inner {\n  background-color: #5562B4;\n  border-color: #5562B4;\n}\n\n.el-checkbox__input.is-checked + .el-checkbox__label {\n  color: #5562B4;\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":true,"importLoaders":2}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1e088213","scoped":false,"hasInlineConfig":false}!./node_modules/px2rem-loader?{"remUnit":54}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/workspace/lite_file.vue
// module id = N3ly
// module chunks = 2